import { Routes } from '@angular/router';

import { LayoutComponent } from './layout.component';
import { authGuard } from './common/core/auth/auth.guard';
import { ConnectLogoutComponent } from './common/core/auth/connect-logout/connect-logout.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'context',
        pathMatch: 'full',
    },
    {
        path: "login",
        loadComponent: () => import('./common/core/auth/login/login.component').then(m => m.LoginComponent)
    },
    {
        path: 'callback',
        loadComponent: () => import('./common/core/auth/callback/callback.component').then(m => m.CallbackComponent)
    },
    {
        path: 'logout',
        loadComponent: () => import('./common/core/auth/logout/logout.component').then(m => m.LogoutComponent)
    },
    {
        path: 'connect-logout',
        component: ConnectLogoutComponent
    },
    {
        path: '',
        component: LayoutComponent,
        canActivateChild: [authGuard],
        children: [
            {
                path: 'customer-onboarding',
                loadComponent: () => import('./customer-onboarding/customer-onboarding.component').then(m => m.CustomerOnboardingComponent)
            },
            {
                path: 'provisioning',
                loadComponent: () => import('./kalmar/provisioning/provisioning.component').then(m => m.ProvisioningComponent)
            },
            {
                path: 'context',
                loadChildren: () => import('./context/context.routes').then(r => r.CONTEXT_ROUTES)
            }
        ]
    },
    {
        path: 'no-connection',
        loadComponent: () => import('./common/core/error/no-connection/no-connection.component').then(m => m.NoConnectionComponent)
    },
    {
        path: 'forbidden',
        loadComponent: () => import('./common/core/error/forbidden/forbidden.component').then(m => m.ForbiddenComponent)
    },
    {
        path: '**',
        loadComponent: () => import('./common/core/error/page-not-found/page-not-found.component').then(m => m.PageNotFoundComponent)
    }
];
